import type { CSSProperties } from "react";
import { useMemo } from "react";

import { pxToRem } from "@/theme/spacing";

interface UseDropdownOptionsViewportStylesInput {
  optionsViewportHeight: number | null;
  maxHeight: number | undefined;
  minHeight: number | undefined;
}

interface UseDropdownOptionsViewportStylesResult {
  optionsViewportStyle: CSSProperties;
  optionsWrapperStyle: CSSProperties;
}

export function useDropdownOptionsViewportStyles({
  optionsViewportHeight,
  maxHeight,
  minHeight,
}: UseDropdownOptionsViewportStylesInput): UseDropdownOptionsViewportStylesResult {
  const optionsWrapperStyle = useMemo<CSSProperties>(
    () => ({
      display: "flex",
      flexDirection: "column",
      gap: pxToRem(8),
    }),
    [],
  );

  const optionsViewportStyle = useMemo<CSSProperties>(
    () => ({
      height:
        optionsViewportHeight === null ? "auto" : `${optionsViewportHeight}px`,
      minHeight: minHeight ? `${minHeight}px` : undefined,
      maxHeight: maxHeight ? `${maxHeight}px` : undefined,
    }),
    [maxHeight, minHeight, optionsViewportHeight],
  );

  return {
    optionsViewportStyle,
    optionsWrapperStyle,
  };
}
